var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAddress01 = function SvgIconAddress01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_address-01_svg2__a",
    x1: 31.21,
    x2: 74.22,
    y1: 6.63,
    y2: 78.56,
    gradientTransform: "matrix(1 0 0 -1 0 102)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_address-01_svg2__a",
    id: "icon_address-01_svg2__b",
    x1: 17.32,
    x2: 60.34,
    y1: 14.94,
    y2: 86.86
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M66.7 66.08c10.64-16.7 9.31-14.62 9.61-15.05 3.88-5.47 5.92-11.9 5.92-18.6C82.23 14.65 67.8 0 50 0S17.77 14.62 17.77 32.42c0 6.7 2.09 13.3 6.09 18.84l9.44 14.81C23.2 67.62 6.05 72.25 6.05 82.42c0 3.71 2.42 9 13.96 13.12C28.07 98.42 38.72 100 50 100c21.1 0 43.95-5.95 43.95-17.58 0-10.18-17.14-14.8-27.25-16.35ZM28.76 48.04c-.03-.05-.07-.1-.1-.15a26.3 26.3 0 0 1-5.03-15.47c0-14.65 11.8-26.56 26.37-26.56s26.37 11.92 26.37 26.56c0 5.47-1.67 10.71-4.82 15.17-.28.37 1.19-1.92-21.56 33.78L28.75 48.04ZM50 94.15c-23.05 0-38.09-6.78-38.09-11.72 0-3.33 7.73-8.79 24.86-10.92L47.53 88.4a2.923 2.923 0 0 0 4.94 0l10.76-16.89c17.13 2.13 24.86 7.6 24.86 10.92 0 4.91-14.91 11.72-38.09 11.72",
    style: {
      fill: "url(#icon_address-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.65 32.42c0-8.08-6.57-14.65-14.65-14.65s-14.65 6.57-14.65 14.65S41.92 47.07 50 47.07s14.65-6.57 14.65-14.65m-23.44 0c0-4.85 3.95-8.79 8.79-8.79s8.79 3.95 8.79 8.79-3.95 8.79-8.79 8.79-8.79-3.95-8.79-8.79",
    style: {
      fill: "url(#icon_address-01_svg2__b)"
    }
  }));
};
export default SvgIconAddress01;